/**
 * Avisos flotantes (toasts): confirmaciones y errores que aparecen y se van solos.
 *
 * Van arriba y centrados a propósito: en un celular sostenido con una mano, la
 * parte de arriba es la única zona que no tapa el pulgar mientras trabajas.
 */

import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import { useAvisos, type TipoAviso } from "@/stores/ui";
import { cx } from "./ui";

const ICONOS: Record<TipoAviso, typeof Info> = {
  exito: CheckCircle2,
  error: AlertCircle,
  info: Info,
};

const ESTILOS: Record<TipoAviso, string> = {
  exito: "border-success/40 bg-success-soft text-success",
  error: "border-danger/40 bg-danger-soft text-danger",
  info: "border-line-strong bg-surface text-ink",
};

export function Avisos() {
  const { avisos, quitar } = useAvisos();

  if (avisos.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex flex-col items-center gap-2 p-3 pt-safe"
      // `aria-live` hace que un lector de pantalla anuncie el aviso en voz alta.
      aria-live="polite"
      role="status"
    >
      {avisos.map((a) => {
        const Icono = ICONOS[a.tipo];
        return (
          <div
            key={a.id}
            className={cx(
              "pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-[var(--radius-control)] border px-4 py-3",
              "shadow-[var(--shadow-pop)] animar-entrada",
              ESTILOS[a.tipo],
            )}
          >
            <Icono size={18} className="mt-0.5 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium">{a.mensaje}</p>
              {a.detalle && <p className="mt-0.5 text-xs opacity-80">{a.detalle}</p>}
            </div>
            <button
              type="button"
              onClick={() => quitar(a.id)}
              aria-label="Cerrar aviso"
              className="-mr-1 shrink-0 rounded p-1 opacity-60 transition-opacity hover:opacity-100"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
